module.exports = __webpack_public_path__ + "static/media/30OIOS5.e119a377.jpg";